var Backbone = require("backbone");

var livingcosts = Backbone.Model.extend({
    defaults: {
    	selectedType: 'rent',
		  costsRent: 900,
		  costsLoan: 900,
		  costsRunning: 200,
		  calc_costsBuy: 0,
		  calc_ownFunds: 0,
		  calc_parcel: 0,
		  calc_house: 0,
		  calc_side: 0,
		  calc_own: 0,
		  calc_interests: 0,
		  calc_period: 20
	  
  }
});

var dailyTrip = Backbone.Model.extend({
	 defaults: {
	 distanceBike: null,
	 enhancedByWebService: false,
	 selectedMode: null,
	 id_car: "1",
	 freq: 5,
	 costs_pt: 0,
	 purposetext: ""
	 }
	 });

var dailyTrips = Backbone.Collection.extend({
	 model: dailyTrip
	 });


var car = Backbone.Model.extend({
	 defaults: {
		 type: null,
		 costs_month: null
	 }
	 });


var cars = Backbone.Collection.extend({
	 model: car
});

var defaultCars = new cars();

defaultCars.add([
	{type: "low", costs_month: 300, consumption_costs_per_m: 0.0000529, co2_per_m: 0.19 /* g/km */ },
	{type: "medium", costs_month: 530, consumption_costs_per_m: 0.00006325, co2_per_m: 0.19},
	{type: "high", costs_month: 690, consumption_costs_per_m: 0.00006555, co2_per_m: 0.19},
	{type: "motorcycle", costs_month: 150, consumption_costs_per_m: 0.0000529, co2_per_m: 0.19}
	]);

var userCars = new cars();
	
userCars.add([
	{id: "1", type: "low", costs_month: 300, consumption_costs_per_m: 0.0000529, co2_per_m: 0.19},
	{id: "2", type: "low", costs_month: 300, consumption_costs_per_m: 0.0000529, co2_per_m: 0.19},
	{id: "3", type: "low", costs_month: 300, consumption_costs_per_m: 0.0000529, co2_per_m: 0.19}
	]);

	var livingplace = Backbone.Model.extend({
		initialize: function () {
			var dT = new dailyTrips()
			dT.on("remove", function(dt) {
				  if (dt.get("feature") && dt.get("layerSource")) {
					  var f = dt.get("feature");
					  var s = dt.get("layerSource");
					  s.removeFeature(f);
				  }
				});
	        this.set("livingcosts", new livingcosts());
	        this.set("dailyTrips", dT);
	        this.set("userCars", userCars);
	        this.set("defaultCars", defaultCars);
	    },
		defaults: {
	      address: "",
	      xy: "",
	      targetroutes: null,
	      lastinframapextent:null
		}
});

module.exports = livingplace



// WEBPACK FOOTER //
// ./src/models/livingplace.js